import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const BothAgentsPresent = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'Both Agents Present', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="both_agents_present"
            title="Both Agents Present"
            subtitle="Automation runs where both listing and selling agents are present"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default BothAgentsPresent;